import { ShopI18nProvider } from './i18n/ShopI18n'
import { useEffect, useState } from 'react'

import MobileShop from './components/MobileShop'
import { assetLoader } from './services/assetLoader'
import { ThemeProvider, ThemeName } from './contexts/ThemeContext'
import { SocketProvider } from './contexts/SocketContext'
import { logger } from './utils/logger'
import { authService } from './services/auth'

function App() {
    // Get theme from URL params or default
    const getThemeFromUrl = (): ThemeName => {
        const params = new URLSearchParams(window.location.search)
        const theme = params.get('theme') as ThemeName
        const validThemes: ThemeName[] = ['default', 'dino-casino', 'superjackpotslots', 'habbo', 'merkur24', 'generic']
        return validThemes.includes(theme) ? theme : 'default'
    }

    const [currentTheme] = useState<ThemeName>(getThemeFromUrl())

    // Initialize authentication service and login if token is present
    useEffect(() => {
        logger.log('AUTH', 'App.tsx useEffect running', {
            currentUrl: window.location.href,
            searchParams: window.location.search,
        })
        
        const initializeAuth = async () => {
            logger.log('AUTH', 'App.tsx initializeAuth starting')
            
            const token = authService.extractAndRemoveTokenFromUrl()
            logger.log('AUTH', 'App.tsx token extraction result', { 
                token: token ? 'found' : 'not found',
                tokenLength: token?.length || 0
            })
            
            if (token) {
                logger.log('AUTH', 'Token found in App.tsx, starting login', {
                    tokenLength: token.length,
                    tokenPreview: `${token.substring(0, 10)}...`,
                })
                try {
                    // Login with token to establish session
                    logger.log('AUTH', 'Calling loginWithToken...')
                    await authService.loginWithToken()
                    logger.log('AUTH', 'Login completed in App.tsx')
                } catch (error) {
                    logger.error('AUTH', 'Failed to login with mobile token:', error)
                }
            } else {
                logger.log('AUTH', 'No token found in App.tsx')
            }
        }
        
        initializeAuth()
    }, [])

    // Initialize asset loader
    useEffect(() => {
        // Set base URL for assets
        assetLoader.setBaseUrl('/assets')
        
        assetLoader.initialize('/whowset-cvs.json').catch((error) => {
            logger.error('ASSET', 'Failed to initialize asset loader:', error)
        })
    }, [])

    return (
        <ShopI18nProvider><ThemeProvider initialTheme={currentTheme}>
            <SocketProvider>
                <div className="min-h-screen w-full">
                    <MobileShop />
                </div>
            </SocketProvider>
        </ThemeProvider></ShopI18nProvider>
    )
}

export default App
